const cards = [
  {
    tag: "近期热议",
    tone: "bg-primary-100 text-primary-700",
    title: "今日看点速览：从主页直达最新内容的正确姿势",
    desc: "想在最短时间找到吃瓜17的最新内容？先记住主站入口，再按看点频道顺序浏览即可，无需在多个网址之间来回翻找。",
    meta: "看点频道 · 更新于今日",
    img: "https://readdy.ai/api/search-image?query=Warm%20minimalist%20editorial%20flat%20lay%20of%20a%20paper%20newspaper%20and%20coffee%20cup%20on%20a%20cream%20surface%2C%20soft%20natural%20morning%20light%2C%20coral%20and%20amber%20accent%20tones%2C%20clean%20composition%2C%20high%20detail&width=800&height=560&seq=exp-card-01&orientation=landscape",
  },
  {
    tag: "入口指南",
    tone: "bg-accent-100 text-accent-800",
    title: "收藏这份吃瓜17网址地址汇总，一次存齐常用链接",
    desc: "把主站、备用、移动页等常用地址统一收进收藏夹，之后每次访问吃瓜17资源页面都能一键直达，不再临时搜索。",
    meta: "使用指南 · 阅读约 2 分钟",
    img: "https://readdy.ai/api/search-image?query=Minimal%20stack%20of%20cream%20envelopes%20with%20small%20bookmark%20ribbons%20and%20warm%20amber%20tones%20on%20a%20soft%20neutral%20background%2C%20clean%20editorial%20photography%2C%20soft%20shadow&width=800&height=560&seq=exp-card-02&orientation=landscape",
  },
  {
    tag: "访问技巧",
    tone: "bg-secondary-200 text-secondary-800",
    title: "主站偶尔波动？记住备用通道这个切换小技巧",
    desc: "当主站入口暂时无法打开，不用反复等待，直接切到备用通道即可继续访问。收藏多个地址，入口更安心。",
    meta: "实用技巧 · 常见问题汇总",
    img: "https://readdy.ai/api/search-image?query=Abstract%20warm%20pathway%20with%20soft%20coral%20and%20gold%20light%20streaks%20through%20a%20minimal%20cream%20space%2C%20representing%20alternative%20routes%2C%20smooth%20gradients%2C%20modern%20editorial&width=800&height=560&seq=exp-card-03&orientation=landscape",
  },
  {
    tag: "内容提醒",
    tone: "bg-accent-100 text-accent-800",
    title: "关注更新动态，入口与内容变动第一时间收到",
    desc: "吃瓜17 的地址和看点频道偶尔会调整。打开本页更新动态区块，就能在刷新后第一时间看到最新变动，减少走空。",
    meta: "更新频道 · 每日汇总",
    img: "https://readdy.ai/api/search-image?query=Warm%20minimal%20desk%20scene%20with%20a%20muted%20gold%20bell%20and%20paper%20notes%20on%20cream%20background%2C%20soft%20lighting%2C%20editorial%20product%20photography%2C%20clean&width=800&height=560&seq=exp-card-04&orientation=landscape",
  },
];

export default function ExploreCards() {
  return (
    <section id="explore" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
          <div className="max-w-2xl">
            <span className="text-xs font-semibold tracking-widest text-accent-700">· 热门看点 · 大图卡片流</span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-black text-foreground-950">访问吃瓜17，先看这篇</h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              标题与导读优先，配图克制点缀。看完这几篇，入口、备用、收藏与访问技巧都能快速上手。
            </p>
          </div>
          <button
            type="button"
            className="shrink-0 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium border border-secondary-300 bg-background-50 text-foreground-700 hover:bg-secondary-100 transition-colors"
          >
            查看全部看点
            <i className="ri-arrow-right-s-line text-base" />
          </button>
        </div>

        <div className="mt-9 grid grid-cols-1 sm:grid-cols-2 gap-5">
          {cards.map((c) => (
            <article
              key={c.title}
              className="group rounded-xl overflow-hidden border border-secondary-200/70 bg-background-100/60 flex flex-col"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={c.img}
                  alt={`吃瓜17 ${c.title}`}
                  title={`吃瓜17 ${c.title}`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className={`absolute top-3 left-3 inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium ${c.tone}`}>
                  {c.tag}
                </span>
              </div>
              <div className="p-5 md:p-6 flex flex-col flex-1">
                <h3 className="text-base md:text-lg font-bold text-foreground-950 leading-snug">{c.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed flex-1">{c.desc}</p>
                <div className="mt-4 flex items-center justify-between border-t border-secondary-200 pt-4">
                  <span className="text-xs text-foreground-500">{c.meta}</span>
                  <button
                    type="button"
                    className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700"
                  >
                    阅读
                    <i className="ri-arrow-right-line text-sm" />
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}